import Experience from "@experience/Experience.js";

const initScene = ({ canvas }) => {
    new Experience(canvas);
};

export { initScene };
